import {Injectable} from '@angular/core';
import {TranslateService} from './translate.service';
import {Filter} from '../search/search-list/filters/filter-block/filter-item/filter';

@Injectable({
  providedIn: 'root'
})
export class SortService {

  constructor(private translator: TranslateService) {

  }

  public sortSelectedThenAlphaFirst(filterA: Filter, filterB: Filter) {
    if (filterA.selected === filterB.selected) {
      return this.sortAlphabeticalFirst(filterA, filterB);
    } else {
      return filterA.selected ? -1 : 1;
    }
  }

  public sortSelectedThenFreqFirst(filterA: Filter, filterB: Filter) {
    if (filterA.selected === filterB.selected) {
      return this.sortFrequencyFirst(filterA, filterB);
    } else {
      return filterA.selected ? -1 : 1;
    }
  }

  public sortFrequencyFirst(filterA: Filter, filterB: Filter) {
    if (filterA.count == filterB.count) {
      return this.sortAlphabetical(filterA, filterB);
    }
    return filterB.count - filterA.count;
  }

  public sortAlphabeticalFirst(filterA: Filter, filterB: Filter) {
    if (filterA.value == filterB.value) {
      return this.sortFrequency(filterA, filterB);
    }
    return this.replaceSpecialCharacters(filterA).localeCompare(this.replaceSpecialCharacters(filterB));
  }

  private sortFrequency(filterA: Filter, filterB: Filter) {
    if (filterA.count == filterB.count) {
      return 0;
    }
    return filterB.count - filterA.count;
  }

  private sortAlphabetical(filterA: Filter, filterB: Filter) {
    if (filterA.value == filterB.value) {
      return 0;
    }
    return this.replaceSpecialCharacters(filterA).localeCompare(this.replaceSpecialCharacters(filterB));
  }

  private replaceSpecialCharacters(filterB: Filter) {

    return this.translator.translate(filterB.value).replace(/[`~!@#$%^&*()_|+-=?;:'"«„”,.<>{}[\]]/gi, '');
  }
}
